module.exports = __webpack_public_path__ + "img/icon_haert.b1fecd0a.svg";